<template>
    <div>
        <v-card outlined class="pa-4 mb-4">
            <div class="d-flex flex-wrap align-center justify-space-between">
                <div>
                    <div class="secao-titulo">Configurações do financeiro</div>
                    <div class="caption grey--text text--darken-1">
                        Taxas de cartão, meta de margem e as listas usadas nos lançamentos.
                    </div>
                </div>

                <v-btn
                    color="green darken-2"
                    dark
                    class="mt-3 mt-md-0"
                    :loading="salvando"
                    @click="salvar"
                >
                    <v-icon left>mdi-content-save</v-icon>
                    Salvar configurações
                </v-btn>
            </div>
        </v-card>

        <v-row>
            <v-col cols="12" md="6">
                <v-card outlined class="pa-4 mb-4">
                    <div class="bloco-titulo">Parâmetros</div>

                    <v-text-field
                        v-model="form.nomeBarbearia"
                        label="Nome da barbearia"
                        outlined
                        dense
                        class="mt-3"
                    ></v-text-field>

                    <campo-valor
                        v-model="form.taxaDebito"
                        suffix="%"
                        label="Taxa do débito"
                        hint="Descontada do valor já líquido de desconto"
                        persistent-hint
                        outlined
                        dense
                    ></campo-valor>

                    <campo-valor
                        v-model="form.taxaCredito"
                        suffix="%"
                        label="Taxa do crédito"
                        outlined
                        dense
                        class="mt-3"
                    ></campo-valor>

                    <campo-valor
                        v-model="form.metaMargem"
                        suffix="%"
                        label="Meta de margem líquida"
                        hint="Usada como referência no painel"
                        persistent-hint
                        outlined
                        dense
                        class="mt-3"
                    ></campo-valor>
                </v-card>
            </v-col>

            <v-col cols="12" md="6">
                <v-card outlined class="pa-4 mb-4">
                    <div class="bloco-titulo">Listas dos lançamentos</div>
                    <div class="caption grey--text text--darken-1 mb-3">
                        Digite e pressione Enter para adicionar; clique no × para remover.
                    </div>

                    <v-combobox
                        v-model="form.formasPagamento"
                        label="Formas de pagamento"
                        multiple
                        chips
                        deletable-chips
                        small-chips
                        outlined
                        dense
                    ></v-combobox>

                    <v-combobox
                        v-model="form.categoriasServico"
                        label="Categorias de serviço"
                        hint="Corte, Barba e Corte + Barba têm percentual próprio de comissão"
                        persistent-hint
                        multiple
                        chips
                        deletable-chips
                        small-chips
                        outlined
                        dense
                        class="mt-3"
                    ></v-combobox>

                    <v-combobox
                        v-model="form.categoriasDespesa"
                        label="Categorias de despesa"
                        multiple
                        chips
                        deletable-chips
                        small-chips
                        outlined
                        dense
                        class="mt-3"
                    ></v-combobox>
                </v-card>
            </v-col>
        </v-row>

        <v-card outlined class="pa-4">
            <div class="bloco-titulo mb-2">Como classificar as despesas</div>
            <div class="body-2 mb-1">
                <strong>Fixa</strong> — repete mesmo com pouco movimento: aluguel, internet, sistema, contador.
            </div>
            <div class="body-2 mb-1">
                <strong>Variável</strong> — muda com o movimento: material descartável, consumo por atendimento.
            </div>
            <div class="body-2">
                <strong>Direta / Indireta</strong> — direta está ligada ao serviço; indireta mantém a operação como um todo.
            </div>
        </v-card>
    </div>
</template>

<script>
import { salvarConfig } from '@/services/financeiro'
import { CONFIG_PADRAO, numero } from '@/services/financeiroCalculos'
import CampoValor from './CampoValor'

export default {
    components: { CampoValor },

    props: ['config', 'usuario'],

    data(){
        return {
            form: { ...CONFIG_PADRAO },
            salvando: false
        }
    },

    watch: {
        config: {
            immediate: true,
            handler(){
                this.sincronizar()
            }
        }
    },

    methods: {
        // Taxas e metas sao gravadas como fracao (0,0399) e editadas
        // como porcentagem (3,99).
        sincronizar(){
            const config = { ...CONFIG_PADRAO, ...(this.config || {}) }
            this.form = {
                ...config,
                taxaDebito: numero(config.taxaDebito) * 100,
                taxaCredito: numero(config.taxaCredito) * 100,
                metaMargem: numero(config.metaMargem) * 100
            }
        },

        async salvar(){
            this.salvando = true
            try {
                await salvarConfig({
                    ...this.form,
                    taxaDebito: numero(this.form.taxaDebito) / 100,
                    taxaCredito: numero(this.form.taxaCredito) / 100,
                    metaMargem: numero(this.form.metaMargem) / 100,
                    mapaCategorias: (this.config || {}).mapaCategorias || {}
                }, this.usuario)

                this.$toasted.global.defaultSuccess('Configurações salvas!')
                this.$emit('recarregar')
            } catch (error) {
                this.$toasted.global.defaultError({ msg: error.message })
            } finally {
                this.salvando = false
            }
        }
    }
}
</script>

<style scoped>
.secao-titulo {
    font-size: 18px;
    font-weight: 800;
    color: #14312d;
}

.bloco-titulo {
    font-size: 15px;
    font-weight: 700;
    color: #14312d;
}
</style>
